import { appColors } from '@/src/theme/foundations/colors'
import { Button, Flex } from '@chakra-ui/react'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface ResetZoomButtonProps {
  onReset: () => void
  isVisible: boolean
  text?: string
}

export const ResetZoomButton: FC<ResetZoomButtonProps> = ({ onReset, isVisible, text }) => {
  const { t } = useTranslation()

  if (!isVisible) return null

  return (
    <Flex justifyContent='flex-end'>
      <Button
        onClick={onReset}
        size='sm'
        variant='ghost'
        color={appColors.primary}
        _hover={{ color: appColors.accentPrimary || appColors.primary }}
        padding={0}
      >
        {text ?? t('components.chart.reset_zoom')}
      </Button>
    </Flex>
  )
}
